import React, { Component } from 'react';
import { StarIcon, MapPinIcon, PhoneIcon, ClockIcon, CheckCircle2Icon, ExternalLinkIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function Contact() {
  const notaryServices = [{
    name: "Marie's Mobile Notary",
    description: 'Highest-rated notary service in Fresno with exceptional customer trust. Specializing in mobile notary services for real estate, legal documents, and personal notarizations. Known for reliability and professional service.',
    address: '4472 N 10th St, Fresno, CA 93726',
    phone: '(559) 903-5902',
    hours: 'Mon-Fri: 2pm - 8pm, Sat: 2pm - 7pm',
    rating: '5.0',
    reviewCount: '78',
    specialty: ['Mobile Service', 'Real Estate', 'Legal Documents'],
    verified: true
  }, {
    name: "Hector Picon's Mobile Notary Service",
    description: 'Most reviewed notary service in Clovis area with nearly 90 five-star reviews. Available 24/7 for emergency notarizations. Trusted by the community for fast, professional, and reliable mobile notary services.',
    address: '635 Barstow Ave #16, Clovis, CA 93612',
    phone: '(559) 800-8000',
    hours: 'Open 24 hours',
    rating: '4.9',
    reviewCount: '88',
    specialty: ['24/7 Service', 'Mobile Notary', 'Emergency Service'],
    verified: true
  }, {
    name: "GG's Notary",
    description: 'Bilingual notary service offering professional notarizations in English and Spanish. Highly professional with flexible hours to accommodate your schedule. Serving Fresno with mobile and in-office services.',
    address: '5555 N Dante Ave, Fresno, CA 93722',
    phone: '(559) 819-0038',
    hours: 'Mon-Sun: 6am - 9:30pm',
    rating: '5.0',
    reviewCount: '16',
    specialty: ['Bilingual', 'Mobile Service', 'Flexible Hours'],
    verified: true
  }, {
    name: "Isaac's Mobile Notary",
    description: 'Available 24 hours a day for all your notarization needs. Experienced mobile notary serving Fresno and surrounding areas. Convenient service for real estate, legal, and personal documents.',
    address: '5771 N Palm Ave, Fresno, CA 93704',
    phone: '(559) 790-2467',
    hours: 'Open 24 hours',
    rating: '4.6',
    reviewCount: '57',
    specialty: ['24/7 Service', 'Mobile Notary', 'Real Estate'],
    verified: true
  }, {
    name: "Carmen's Mobile Notary",
    description: 'Round-the-clock mobile notary service providing convenient notarizations at your location. Serving Fresno with professional and timely service for all types of documents.',
    address: '5771 N Palm Ave, Fresno, CA 93704',
    phone: '(559) 307-3723',
    hours: 'Open 24 hours',
    rating: '4.2',
    reviewCount: '24',
    specialty: ['24/7 Service', 'Mobile Notary', 'All Documents'],
    verified: true
  }, {
    name: "Tina's Notary Service",
    description: 'Clovis-based notary service specializing in immigration documents and general notarizations. Available 24/7 to meet your urgent notarization needs. Experienced and professional service.',
    address: 'Clovis, CA 93619',
    phone: '(559) 300-4331',
    hours: 'Open 24 hours',
    rating: '5.0',
    reviewCount: '22',
    specialty: ['Immigration Docs', '24/7 Service', 'Mobile Notary'],
    verified: true
  }, {
    name: 'Notary 24/7',
    description: 'Convenient mobile and walk-in notary service available around the clock. Perfect for last-minute notarizations and emergency situations. Professional service you can count on anytime.',
    address: '6227 W Northdale Ave, Fresno, CA 93723',
    phone: '(559) 286-9523',
    hours: 'Open 24 hours',
    rating: '5.0',
    reviewCount: '2',
    specialty: ['24/7 Service', 'Walk-In', 'Mobile Service'],
    verified: true
  }];
  return <section id="contact" className="py-24 bg-slate-50 relative overflow-hidden" data-id="element-43">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-44">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-45">
          <FadeIn data-id="element-46">
            <p className="text-blue-600 font-semibold tracking-wide uppercase text-sm mb-3" data-id="element-47">
              Fresno Directory
            </p>
            <h2 className="text-3xl md:text-4xl font-semibold text-slate-900 mb-6" data-id="element-48">
              Top-Rated <span className="text-gradient" data-id="element-49">Notary Public</span>{' '}
              Services in Fresno, CA
            </h2>
            <p className="text-lg text-slate-600" data-id="element-50">
              Looking for a{' '}
              <strong className="font-medium text-slate-800" data-id="element-51">
                mobile notary in Fresno
              </strong>
              ? Browse our directory of trusted, licensed, and highly-rated
              notary services with verified reviews. Compare 24/7 availability,
              pricing, and specialties to find the best{' '}
              <strong className="font-medium text-slate-800" data-id="element-52">
                notary near you in Fresno County
              </strong>
              .
            </p>
          </FadeIn>
        </div>

        {/* Directory Listings */}
        <div className="space-y-6" data-id="element-53">
          {notaryServices.map((service, index) => <FadeIn key={index} delay={index * 50} data-id="element-54">
              <div className="group bg-white border border-slate-200 rounded-xl overflow-hidden transition-all duration-300 hover:shadow-xl hover:border-blue-200" data-id="element-55">
                <div className="p-6 md:p-8" data-id="element-56">
                  <div className="flex flex-col lg:flex-row gap-6" data-id="element-57">
                    {/* Left Side - Business Image/Logo Placeholder */}
                    <div className="flex-shrink-0" data-id="element-58">
                      <div className="w-full lg:w-32 h-32 bg-gradient-to-br from-blue-100 to-blue-50 rounded-lg flex items-center justify-center border border-blue-100" data-id="element-59">
                        <div className="text-center" data-id="element-60">
                          <div className="w-16 h-16 mx-auto bg-blue-600 rounded-full flex items-center justify-center text-white text-2xl font-bold mb-2" data-id="element-61">
                            {service.name.charAt(0)}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Middle - Business Info */}
                    <div className="flex-grow" data-id="element-62">
                      {/* Name and Verified Badge */}
                      <div className="flex items-start gap-3 mb-3" data-id="element-63">
                        <h4 className="text-xl md:text-2xl font-semibold text-slate-900 group-hover:text-blue-600 transition-colors" data-id="element-64">
                          {service.name}
                        </h4>
                        {service.verified && <div className="flex-shrink-0 mt-1" data-id="element-65">
                            <div className="bg-blue-50 border border-blue-200 rounded-full px-2 py-0.5 flex items-center gap-1" data-id="element-66">
                              <CheckCircle2Icon className="w-3.5 h-3.5 text-blue-600" data-id="element-67" />
                              <span className="text-xs font-medium text-blue-700" data-id="element-68">
                                Verified
                              </span>
                            </div>
                          </div>}
                      </div>

                      {/* Google-style Rating */}
                      <div className="flex items-center gap-3 mb-4" data-id="element-69">
                        <div className="flex items-center gap-2" data-id="element-70">
                          <div className="flex items-center gap-0.5" data-id="element-71">
                            {[...Array(5)].map((_, i) => <StarIcon key={i} className={`w-4 h-4 ${i < Math.floor(parseFloat(service.rating)) ? 'fill-yellow-400 text-yellow-400' : 'text-slate-300'}`} data-id="element-72" />)}
                          </div>
                          <span className="text-sm font-semibold text-slate-900" data-id="element-73">
                            {service.rating}
                          </span>
                        </div>
                        <div className="flex items-center gap-2" data-id="element-74">
                          {/* Google Logo */}
                          <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" data-id="element-75">
                            <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4" data-id="element-76" />
                            <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" data-id="element-77" />
                            <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05" data-id="element-78" />
                            <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" data-id="element-79" />
                          </svg>
                          <span className="text-sm text-slate-600" data-id="element-80">
                            ({service.reviewCount} reviews)
                          </span>
                        </div>
                      </div>

                      {/* Description */}
                      <p className="text-slate-600 leading-relaxed mb-4" data-id="element-81">
                        {service.description}
                      </p>

                      {/* Specialty Tags */}
                      <div className="flex flex-wrap gap-2 mb-4" data-id="element-82">
                        {service.specialty.map((spec, idx) => <span key={idx} className="inline-flex items-center px-3 py-1 rounded-full bg-blue-50 border border-blue-100 text-blue-700 text-xs font-medium" data-id="element-83">
                            {spec}
                          </span>)}
                      </div>

                      {/* Contact Info Grid */}
                      <div className="grid sm:grid-cols-3 gap-4 pt-4 border-t border-slate-100" data-id="element-84">
                        <div className="flex items-start gap-2" data-id="element-85">
                          <MapPinIcon className="w-4 h-4 text-slate-400 flex-shrink-0 mt-0.5" data-id="element-86" />
                          <div data-id="element-87">
                            <div className="text-xs text-slate-500 mb-0.5" data-id="element-88">
                              Address
                            </div>
                            <div className="text-sm text-slate-700 font-medium" data-id="element-89">
                              {service.address}
                            </div>
                          </div>
                        </div>
                        <div className="flex items-start gap-2" data-id="element-90">
                          <PhoneIcon className="w-4 h-4 text-slate-400 flex-shrink-0 mt-0.5" data-id="element-91" />
                          <div data-id="element-92">
                            <div className="text-xs text-slate-500 mb-0.5" data-id="element-93">
                              Phone
                            </div>
                            <div className="text-sm text-slate-700 font-medium" data-id="element-94">
                              {service.phone}
                            </div>
                          </div>
                        </div>
                        <div className="flex items-start gap-2" data-id="element-95">
                          <ClockIcon className="w-4 h-4 text-slate-400 flex-shrink-0 mt-0.5" data-id="element-96" />
                          <div data-id="element-97">
                            <div className="text-xs text-slate-500 mb-0.5" data-id="element-98">
                              Hours
                            </div>
                            <div className="text-sm text-slate-700 font-medium" data-id="element-99">
                              {service.hours}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Right Side - CTA */}
                    <div className="flex-shrink-0 flex lg:flex-col gap-3 lg:justify-center" data-id="element-100">
                      <a href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(service.address)}`} target="_blank" rel="noopener noreferrer" className="flex-1 lg:flex-none inline-flex items-center justify-center gap-2 px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium transition-all hover:shadow-lg text-sm" data-id="element-101">
                        View Details
                        <ExternalLinkIcon className="w-4 h-4" data-id="element-102" />
                      </a>
                      <a href={`tel:${service.phone.replace(/[^0-9]/g, '')}`} className="flex-1 lg:flex-none inline-flex items-center justify-center gap-2 px-6 py-3 bg-white hover:bg-slate-50 text-slate-700 border border-slate-200 rounded-lg font-medium transition-all text-sm" data-id="element-103">
                        <PhoneIcon className="w-4 h-4" data-id="element-104" />
                        Call Now
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>

        {/* Bottom Info */}
        <FadeIn delay={300} data-id="element-105">
          <div className="mt-12 text-center max-w-2xl mx-auto" data-id="element-106">
            <div className="bg-blue-50 border border-blue-100 rounded-xl p-6" data-id="element-107">
              <p className="text-slate-700 leading-relaxed" data-id="element-108">
                <strong className="font-semibold text-slate-900" data-id="element-109">
                  Directory Information:
                </strong>{' '}
                The listings above represent some of the top-rated{' '}
                <strong className="font-medium text-slate-800" data-id="element-110">
                  fresno ca notary services
                </strong>
                . We recommend contacting each service directly to verify
                current availability, pricing, and service areas.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}